import React from 'react';
import _ from 'lodash';
import EmptyValue, { isBlankValue } from 'src/common/display/EmptyValue';
import defaultLabels from 'src/constants/labels';

export const careCoordinatorColumn = () => ({
  label: defaultLabels.CareCoordinator,
  sortColumn: 'care_coordinator.user.full_name',
});

export const clientNameColumn = (setSort, onSortColumn) => ({
  label: 'Client Name',
  sortColumn: 'person.full_name',
  ...(setSort && onSortColumn && {
    sortBy: setSort?.sidx,
    sortDirection: setSort.sord,
    setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
  }),
});

export const lastUpdatedColumn = () => ({
  label: 'Last Updated',
  sortColumn: 'updated_at',
  type: 'date',
});

export const networkColumn = (isSuperNetwork, path = 'referred_to_network.name') => {
  if (!isSuperNetwork) {
    return null;
  }
  return {
    label: 'Network',
    sortColumn: path,
  };
};

export const serviceTypeColumn = () => ({
  label: 'Service Type',
  sortColumn: 'service.name',
});

export const PROGRAM_COLUMN_LAYOUT = {
  columnWidth: '40%',
  wrap: true,
};

// Shows a muted "—" for a missing Program Name. `isEmpty` lets DynamicTableRowColumn skip the clamp/tooltip.
export const programEmptyValue = (sortColumn) => ({
  formatData: (item) => {
    const value = _.get(item, sortColumn);
    return isBlankValue(value) ? <EmptyValue /> : value;
  },
  isEmpty: (item) => isBlankValue(_.get(item, sortColumn)),
});

export const programColumn = (sortColumn = 'referred_to_program.name', currentSort, onSortColumn) => ({
  ...PROGRAM_COLUMN_LAYOUT,
  ...programEmptyValue(sortColumn),
  label: 'Program',
  sortColumn,
  ...(currentSort && onSortColumn && {
    sortBy: currentSort?.sidx,
    sortDirection: currentSort.sord,
    setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
  }),
});
